import { Component, Input, OnInit } from '@angular/core';
import { SNSMSMessage } from 'src/app/models/snsmsmessage';

@Component({
  selector: 'app-sms-table',
  templateUrl: './sms-table.component.html',
  styleUrls: ['./sms-table.component.scss']
})
export class SmsTableComponent implements OnInit {

  @Input() messages: SNSMSMessage[] = [];
  displayedColumns: string[] = ['message'];

  constructor() { }

  ngOnInit(): void {
  }

}
